module.exports = __webpack_public_path__ + "static/5-aafd42e5138301b013b1f49ff7ff659c.jpg";